import { appConfig, geoData, targetEnv } from '@fs/zion-config'

let locations

// default locations to block in case of no environment variable present
const DEFAULT_LOCATIONS = ['CN', 'RU']

export default {
  get blockedLocations() {
    if (locations) {
      return locations
    }
    locations =
      appConfig?.BLOCKED_LOCATIONS?.trim()
        ?.split(',')
        ?.map((x) => x.trim())
        ?.filter(Boolean) || DEFAULT_LOCATIONS
    return locations
  },
  get userLocationBlocked() {
    const userLocation = targetEnv === 'local' ? 'US' : geoData?.country
    return this.blockedLocations.includes(userLocation)
  },
}
